import { useBriefApproval } from "../../hooks/useApprovals";
import { approvalPublishNote, approverLabel, formatApprovalTime, POST_APPROVAL_STATES } from "../../lib/approval-display";
import type { BriefState } from "../../../../shared/types";

/** On an approved brief: who approved it and when, and that approval did not publish it. */
export function BriefApprovalNote({ campaignId, brief }: { campaignId: string; brief: { id: string; state: string; surface?: string | null } }) {
  const approvedState = POST_APPROVAL_STATES.has(brief.state as BriefState);
  const approval = useBriefApproval(campaignId, brief.id, approvedState);
  if (!approvedState) return null;
  const when = formatApprovalTime(approval.data?.approved_at ?? null);
  return (
    <section aria-label="Approval" className="border-t border-slate-200 bg-emerald-50/60 px-5 py-3 text-sm text-emerald-950">
      <p className="font-medium">
        {when ? `Approved by ${approverLabel(approval.data?.approved_by ?? null)} at ${when}.`
          : approval.isLoading ? "Approved."
          : approval.isError ? "Approved. Who approved it could not be loaded right now."
          : "Approved (approval time not recorded)."}
      </p>
      <p className="mt-1 text-emerald-900">
        {brief.state === "published" ? "It was published separately after approval." : approvalPublishNote(brief.surface)}
      </p>
    </section>
  );
}
